var m = (o, t, a) => new Promise((f, n) => {
  var i = (r) => {
    try {
      e(a.next(r));
    } catch (s) {
      n(s);
    }
  }, p = (r) => {
    try {
      e(a.throw(r));
    } catch (s) {
      n(s);
    }
  }, e = (r) => r.done ? f(r.value) : Promise.resolve(r.value).then(i, p);
  e((a = a.apply(o, t)).next());
});
import { selfAxios as c } from "@oppein/op-utils";
function l(o) {
  return m(this, null, function* () {
    const { data: t } = yield c.post(
      "/bsplatform/external/commodity/transferQueryParam",
      o
    );
    return t == null ? void 0 : t.data;
  });
}
export {
  l as postTransferQueryParam
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/bsplatform/external/commodity/transferQueryParam/post.js
// module id = 1802
// module chunks = 67